import React, { useContext, useMemo } from 'react';
import ProgressBar from './ProgressBar';
import { ProgressTitle, Progress } from './styled';
import { ContextoListaApartamentos } from '../ApartamentList/contextoImoveis';
import EmptyState from './EmptyState';
import { ReactComponent as Fundacao } from '../../assets/novosicones/minha-obra/Fundacao.svg';
import { ReactComponent as Estrutura } from '../../assets/novosicones/minha-obra/Estrutura.svg';
import { ReactComponent as Acabamento } from '../../assets/novosicones/minha-obra/Acabamento.svg';
import { ReactComponent as Alvenaria } from '../../assets/novosicones/minha-obra/Alvenaria.svg';
import { ReactComponent as AreaExterna } from '../../assets/novosicones/minha-obra/AreaExterna.svg';
import { ReactComponent as EvolucaoDaObra } from '../../assets/novosicones/minha-obra/EvolucaoDaObra.svg';
import { ReactComponent as Instalacoes } from '../../assets/novosicones/minha-obra/Instalacoes.svg';
import DianaRivaImage from '../../assets/diana/riva/Diana-avanço-obras.png';
import DianaDirecionalImage from '../../assets/diana/direcional/Diana-avanço-obras.png';

import Fade from '@material-ui/core/Fade';

import './styles.scss';

const MinhaObra = ({ status }) => {
  const { tema } = useContext(ContextoListaApartamentos);

  const isAnyStatusFilled = useMemo(() => {
    const statusKeys = Object.keys(status);

    const isAnyStatusFilled = statusKeys.some(
      (statusName) => status[statusName] > 0
    );

    return isAnyStatusFilled;
  }, [status]);

  let stringClasseTema = tema.tipo == 'Riva' ? 'temaRiva' : 'temaDirecional';

  const EmptyStatusImageSrc =
    tema.tipo == 'Riva' ? DianaRivaImage : DianaDirecionalImage;

  return (
    <Fade in>
      <div className='minhaObra'>
        <div
          className='minhaObra__title centralized'
          style={{ backgroundColor: tema.primaryColor, transition: '0.3s' }}
        >
          <span>MINHA OBRA</span>
        </div>
        {isAnyStatusFilled ? (
          <div className='minhaObra__obras'>
            <ul>
              <li className='centralized-space-between'>
                <Fundacao
                  className={
                    status.fundacao < 100 ? 'temaEmpty' : stringClasseTema
                  }
                />
                <div className='centralized-column minhaObra__obras__item'>
                  <div className='percentual centralized-space-between minhaObra__obras__item__dados'>
                    <ProgressTitle progress={status.fundacao} tema={tema}>
                      Fundação
                    </ProgressTitle>{' '}
                    <Progress progress={status.fundacao} tema={tema}>
                      {status.fundacao}%
                    </Progress>
                  </div>
                  <ProgressBar
                    bgcolor={'#000000'}
                    completed={status.fundacao}
                    tema={tema}
                  />
                </div>
              </li>
              <li className='centralized-space-between'>
                <Estrutura
                  className={
                    status.estrutura < 100 ? 'temaEmpty' : stringClasseTema
                  }
                />

                <div className='centralized-column minhaObra__obras__item'>
                  <div className='percentual centralized-space-between minhaObra__obras__item__dados'>
                    <ProgressTitle progress={status.estrutura} tema={tema}>
                      Estrutura
                    </ProgressTitle>{' '}
                    <Progress progress={status.estrutura} tema={tema}>
                      {status.estrutura}%
                    </Progress>
                  </div>
                  <ProgressBar
                    bgcolor={'#000000'}
                    completed={status.estrutura}
                    tema={tema}
                  />
                </div>
              </li>
              <li className='centralized-space-between'>
                <Acabamento
                  className={
                    status.acabamento < 100 ? 'temaEmpty' : stringClasseTema
                  }
                />
                <div className='centralized-column minhaObra__obras__item'>
                  <div className='percentual centralized-space-between minhaObra__obras__item__dados'>
                    <ProgressTitle progress={status.acabamento} tema={tema}>
                      Acabamento
                    </ProgressTitle>{' '}
                    <Progress progress={status.acabamento} tema={tema}>
                      {status.acabamento}%
                    </Progress>
                  </div>
                  <ProgressBar
                    bgcolor={'#000000'}
                    completed={status.acabamento}
                    tema={tema}
                  />
                </div>
              </li>
              <li className='centralized-space-between'>
                <Alvenaria
                  className={
                    status.alvenaria < 100 ? 'temaEmpty' : stringClasseTema
                  }
                />
                <div className='centralized-column minhaObra__obras__item'>
                  <div className='percentual centralized-space-between minhaObra__obras__item__dados'>
                    <ProgressTitle progress={status.alvenaria} tema={tema}>
                      Alvenaria
                    </ProgressTitle>{' '}
                    <Progress progress={status.alvenaria} tema={tema}>
                      {status.alvenaria}%
                    </Progress>
                  </div>
                  <ProgressBar
                    bgcolor={'#000000'}
                    completed={status.alvenaria}
                    tema={tema}
                  />
                </div>
              </li>
              <li className='centralized-space-between'>
                <AreaExterna
                  className={
                    status.area_externa < 100 ? 'temaEmpty' : stringClasseTema
                  }
                />
                <div className='centralized-column minhaObra__obras__item'>
                  <div className='percentual centralized-space-between minhaObra__obras__item__dados'>
                    <ProgressTitle progress={status.area_externa} tema={tema}>
                      Área Externa
                    </ProgressTitle>{' '}
                    <Progress progress={status.area_externa} tema={tema}>
                      {status.area_externa}%
                    </Progress>
                  </div>
                  <ProgressBar
                    bgcolor={'#000000'}
                    completed={status.area_externa}
                    tema={tema}
                  />
                </div>
              </li>
              <li className='centralized-space-between'>
                <EvolucaoDaObra
                  className={
                    status.evolucao_obra < 100 ? 'temaEmpty' : stringClasseTema
                  }
                />
                <div className='centralized-column minhaObra__obras__item'>
                  <div className='percentual centralized-space-between minhaObra__obras__item__dados'>
                    <ProgressTitle progress={status.evolucao_obra} tema={tema}>
                      Evolução da Obra
                    </ProgressTitle>{' '}
                    <Progress progress={status.evolucao_obra} tema={tema}>
                      {status.evolucao_obra}%
                    </Progress>
                  </div>
                  <ProgressBar
                    bgcolor={'#000000'}
                    completed={status.evolucao_obra}
                    tema={tema}
                  />
                </div>
              </li>
              <li className='centralized-space-between'>
                <Instalacoes
                  className={
                    status.instalacoes < 100 ? 'temaEmpty' : stringClasseTema
                  }
                />
                <div className='centralized-column minhaObra__obras__item'>
                  <div className='percentual centralized-space-between minhaObra__obras__item__dados'>
                    <ProgressTitle progress={status.instalacoes} tema={tema}>
                      Instalações
                    </ProgressTitle>{' '}
                    <Progress progress={status.instalacoes} tema={tema}>
                      {status.instalacoes}%
                    </Progress>
                  </div>
                  <ProgressBar
                    bgcolor={'#000000'}
                    completed={status.instalacoes}
                    tema={tema}
                  />
                </div>
              </li>
            </ul>
          </div>
        ) : (
          <EmptyState
            imageSrc={EmptyStatusImageSrc}
            title='Evolução da obra a iniciar'
            text='Não se preocupe, quando o avanço das obras começar você poderá acompanhar por aqui.'
            tema={tema}
            marginTop={'45px'}
          />
        )}
      </div>
    </Fade>
  );
};

export default MinhaObra;
